const handleDeepArraySubKey = (subkey) => (!isNaN(Number(subkey)) ? `[${subkey}]` : subkey);
const handleSubKey = (key, subKey, parentIsArray, valueIsArray) => {
    if (parentIsArray) {
        return `[${key}]${valueIsArray ? handleDeepArraySubKey(subKey) : `.${subKey}`}`;
    }
    else if (valueIsArray) {
        return `${key}${handleDeepArraySubKey(subKey)}`;
    }
    return `${key}.${subKey}`;
};
/**
 * get keys from all levels in an object
 * @param {any} obj
 * @param {boolean?} excludeParentKeys - exclude parent levels in the returned array
 * @param {boolean?} excludeUndefined - if the value for an entry is undefined, exclude that key
 * @returns {Array<string>}
 */
function getDeepKeys(obj, excludeParentKeys = false, excludeUndefined = false) {
    const parentIsArray = Array.isArray(obj);
    return Object.entries(obj).reduce((keys, entry) => {
        const [key, value] = entry;
        if (excludeUndefined && typeof value === 'undefined') {
            return keys;
        }
        const valueIsObject = typeof value === 'object';
        if (!excludeParentKeys || (excludeParentKeys && !valueIsObject)) {
            keys.push(key);
        }
        // process sub-levels
        if (valueIsObject) {
            const valueIsArray = Array.isArray(value);
            const subKeys = getDeepKeys(value, excludeParentKeys, excludeUndefined).map((subKey) => handleSubKey(key, subKey, parentIsArray, valueIsArray));
            return [...keys, ...subKeys];
        }
        return keys;
    }, []);
}
export default getDeepKeys;
//# sourceMappingURL=getDeepKeys.js.map